

<template>
    <App class="uav-project-editor">
       <AppBar>
          <div class="flex-wrap">
            <BaseIcon icon="Building-" size="25" color="var(--primary)" style="margin-right:10px" />
            <a style="color:var(--primary);margin-right:5px;" @click="RouteTo('/core/uav-project')">全景720场景设计</a> / {{ project.name }}
          </div>
          <div class="flex-wrap">
    
            <ButtonGroup size="small">
                <Button type="primary">设计</Button>
                <Button @click="RouteTo(`/core/uav-projects/${project.id}/view`,true)">预览</Button>
                <Button @click="onShare">分享</Button>
            </ButtonGroup>
    
          </div>
          <div class="flex-wrap split5">
           
               
          </div>
        </AppBar>
       <AppMask v-if="!is_ready" />
      <AppLeft class="flex-line flex-col align-stretch">
        <!-- 场景面板 -->
        <div class="uav-panel" style="min-height:50%;border-bottom:1px solid var(--border)">
            <div class="uav-panel-header">
              <BaseIcon icon="md-list" size="16" color="var(--primary)" />
              <span class="uav-panel-title">场景 Scene</span>
            </div>
            <div class="uav-panel-content">
              <template v-if="!scenes || scenes.length === 0">
                <div class="uav-empty-panel" @click="createScene">
                  <BaseIcon icon="md-add" size="40" color="var(--subtext)" />
                  <div style="margin-top:10px;color:var(--subtext)">创建场景</div>
                </div>
              </template>
              <template v-else>
                <div class="uav-scene-list">
                  <draggable
                    v-model="scenes"
                    :options="{animation: 300, handle: '.drag-handle'}"
                    @end="handleSceneSortEnd"
                  >
                    <div 
                      v-for="scene in scenes" 
                      :key="scene.id"
                      :class="[
                        'uav-scene-item', 
                        { 
                          'uav-scene-selected': selectedScene && selectedScene.id === scene.id,
                          'uav-scene-drag-over': dragOverScene && dragOverScene.id === scene.id
                        }
                      ]"
                      @click="selectScene(scene)"
                      @dragover.prevent="handleViewDragOverScene(scene, $event)"
                      @dragleave="handleViewDragLeaveScene(scene, $event)"
                      @drop.prevent="handleViewDropToScene(scene)"
                    >
                      <BaseIcon icon="md-menu" size="16" color="var(--subtext)" class="drag-handle" />
                      <BaseIcon icon="md-folder" size="20" color="var(--hover-text)" />
                      <span class="uav-scene-name">{{ scene.name }}</span>
                    </div>
                  </draggable>
                  <div class="uav-scene-item uav-scene-add" @click="createScene">
                    <BaseIcon icon="md-add" size="20" color="var(--subtext)" />
                    <span class="uav-scene-name">创建新场景</span>
                  </div>
                </div>
              </template>
            </div>
        </div>
        
        <!-- 视图面板 -->
        <div class="uav-panel">
            <div class="uav-panel-header">
              <BaseIcon icon="md-eye" size="16" color="var(--primary)" />
              <span class="uav-panel-title">视图 View</span>
            </div>
            <div 
              class="uav-panel-content"
              :class="{ 'uav-panel-drop-zone': isDraggingFile }"
              @dragenter="handleFileDragEnter"
              @dragleave="handleFileDragLeave"
              @dragover.prevent
              @drop.prevent="handleFileDrop"
            >
              <template v-if="!selectedScene">
                <div class="uav-empty-hint">
                  <BaseIcon icon="md-information-circle" size="30" color="var(--subtext)" />
                  <div style="margin-top:10px;color:var(--subtext);font-size:12px;">请先选择一个场景</div>
                </div>
              </template>
              <template v-else-if="!views || views.length === 0">
                <div class="uav-empty-panel" @click="createView">
                  <BaseIcon icon="md-add" size="40" color="var(--subtext)" />
                  <div style="margin-top:10px;color:var(--subtext)">上传全景图片</div>
                  <div style="margin-top:5px;color:var(--subtext);font-size:11px;">或拖拽图片到此处</div>
                </div>
              </template>
              <template v-else>
                <div class="uav-scene-list">
                  <draggable
                    v-model="views"
                    :options="{animation: 300, handle: '.drag-handle'}"
                    @end="handleViewSortEnd"
                  >
                    <div 
                      v-for="view in views" 
                      :key="view.id"
                      :class="[
                        'uav-scene-item', 
                        'uav-view-item',
                        { 
                          'uav-scene-selected': selectedView && selectedView.id === view.id,
                          'uav-view-dragging': draggingView && draggingView.id === view.id
                        }
                      ]"
                      @click="selectView(view)"
                    >
                      <BaseIcon icon="md-menu" size="16" color="var(--subtext)" class="drag-handle" />
                      <BaseIcon icon="photo" size="18" color="var(--hover-text)" />
                      <span class="uav-scene-name">{{ view.name }}</span>
                      <BaseIcon 
                        icon="md-move" 
                        size="14" 
                        color="var(--subtext)" 
                        class="uav-view-drag-handle"
                        title="拖拽到其他场景"
                        draggable="true"
                        @dragstart.stop="handleViewDragToSceneStart(view, $event)"
                        @dragend.stop="handleViewDragToSceneEnd"
                      />
                    </div>
                  </draggable>
                  <div class="uav-scene-item uav-scene-add" @click="createView">
                    <BaseIcon icon="md-add" size="20" color="var(--subtext)" />
                    <span class="uav-scene-name">上传全景图片</span>
                  </div>
                </div>
                <div v-if="isDraggingFile" class="uav-drop-overlay">
                  <BaseIcon icon="md-cloud-upload" size="60" color="var(--primary)" />
                  <div style="margin-top:15px;color:var(--primary);font-size:16px;font-weight:600;">释放以上传图片</div>
                </div>
              </template>
            </div>
        </div>
      </AppLeft>
      
        <!-- 右侧配置面板 -->
        <AppRight :width="200">
          <!-- 沙盒面板 -->
          <div class="uav-sandbox-panel" style="border-bottom:1px solid var(--border);height:350px;">
            <div class="uav-panel-header" style="justify-content:space-between;">
              <div style="display:flex;align-items:center;gap:4px;">
                <BaseIcon icon="md-boxes" size="16" color="var(--primary)" />
                <span class="uav-panel-title">沙盒 Sandbox</span>
              </div>
              <Button 
                v-if="sandbox" 
                size="small" 
                icon="md-refresh" 
                @click="updateSandbox"
                style="margin-right:5px;"
              >
                重传
              </Button>
            </div>
            <div class="uav-panel-content">
              <template v-if="!selectedScene">
                <div class="uav-empty-hint">
                  <BaseIcon icon="md-information-circle" size="30" color="var(--subtext)" />
                  <div style="margin-top:10px;color:var(--subtext);font-size:12px;">请先选择一个场景</div>
                </div>
              </template>
              <template v-else-if="!sandbox">
                <div class="uav-empty-panel" @click="createSandbox">
                  <BaseIcon icon="md-add" size="40" color="var(--subtext)" />
                  <div style="margin-top:10px;color:var(--subtext)">创建沙盒</div>
                </div>
              </template>
              <template v-else>
                <SandboxMap 
                  :key="sandbox.id + '-' + sandbox.url"
                  :sandbox="sandbox"
                  :scenes="scenes"
                  :views="views"
                  :selectedView="selectedView"
                  @update-position="handleUpdateSandboxPosition"
                  @select-view="handleSandboxSelectView"
                  @on-change="handleSandboxChange"
                />
              </template>
            </div>
          </div>
          
          <!-- 属性面板 -->
          <div class="uav-config-panel" style="height:calc(100% - 350px);">
            <div class="uav-panel-header">
              <BaseIcon icon="md-list" size="16" color="var(--primary)" />
              <span class="uav-panel-title">属性 Property</span>
            </div>
            <template v-if="!selectedView">
              <div class="uav-empty-config">
                <BaseIcon icon="md-information-circle" size="40" color="var(--subtext)" />
                <div style="margin-top:15px;color:var(--subtext)">请选择一个视图</div>
              </div>
            </template>
            <template v-else>
              <div class="uav-config-content">
                <!-- 场景属性 -->
                <div class="uav-config-section" v-if="selectedScene">
                  <div class="uav-config-section-title">
                    <span>场景</span>
                    <BaseIcon 
                      v-if="sceneDataChanged"
                      icon="save" 
                      size="14" 
                      color="var(--primary)" 
                      style="cursor:pointer;margin-left:auto;padding:2px;border:1px solid var(--border);margin-right:5px;"
                      @click="saveSceneData"
                      title="保存场景属性"
                    />
                  </div>
                  <BaseProperty 
                    v-model="sceneData"
                    :attrs="sceneConfig"
                  />
                </div>
                
                <!-- 视图属性 -->
                <div class="uav-config-section">
                  <div class="uav-config-section-title">
                    <span>视图</span>
                    <BaseIcon 
                      v-if="viewDataChanged"
                      icon="save" 
                      size="14" 
                      color="var(--primary)" 
                style="cursor:pointer;margin-left:auto;padding:2px;border:1px solid var(--border);margin-right:5px;"
                      @click="saveViewData"
                      title="保存视图属性"
                    />
                  </div>
                  <BaseProperty 
                    v-model="viewData"
                    :attrs="viewConfig"
                  />
              
                  <BaseProperty 
                    v-model="viewOption"
                    :attrs="viewOptionConfig"
                  />
               
                  <BaseProperty 
                    v-model="sandboxData"
                    :attrs="sandboxPositionConfig"
                  />
                </div>
              </div>
            </template>
          </div>
        </AppRight>
    
        <!-- 中间视口 -->
        <AppClient style="background:var(--bg1);height:100%;overflow:hidden;" :collapse-left="true" :collapse-right="true">
            <div class="uav-panel-header">
                <BaseIcon icon="md-list" size="16" color="var(--primary)" />
                <span class="uav-panel-title">当前场景 Current</span>
            </div>
            <div style="height:calc(100% - 32px);position:relative;width:100%">
          <template v-if="selectedView && selectedView.url">
            <UAVRenderEditor 
              :src="selectedView.url"
              :fast-url="selectedView.fast_url || ''"
              :project-id="project ? project.id : null"
              :scene-id="selectedScene ? selectedScene.id : null"
              :view-id="selectedView ? selectedView.id : null"
              :option="viewOption"
              @rotation-change="handleRotationChange"
            />
          </template>
          <template v-else>
            <div class="uav-empty-viewport">
              <BaseIcon icon="md-eye-off" size="60" color="var(--subtext)" />
              <div style="margin-top:20px;color:var(--text1);font-size:16px;">
                {{ selectedView ? '请为视图设置全景图片' : '请选择一个视图' }}
              </div>
            </div>
          </template>
        </div>
        </AppClient>
    
        <!-- 创建场景Modal -->
        <Modal 
          v-model="showCreateSceneModal" 
          title="创建场景" 
          @on-ok="confirmCreateScene"
          @on-cancel="cancelCreateScene"
        >
          <Input 
            v-model="newSceneName" 
            placeholder="请输入场景名称"
            @on-enter="confirmCreateScene"
            autofocus
          />
        </Modal>
    
        <!-- 创建沙盒Modal -->
        <Modal 
          v-model="showSandboxCropModal" 
          title="裁剪沙盒图片"
          width="600"
          footer-hide
        >
          <div style="padding:20px;">
            <GFormImageClip 
              v-model="sandboxImageUrl" 
              :editable="true" 
              style="width:400px;height:300px;"
              :option="{
                uploader:'session/upload',
                w2h: 4/3
              }"
              @change="handleSandboxImageCropped"
            />
          </div>
          <div class="flex-wrap flex-end" style="margin-top:20px;padding:0 20px 20px;">
            <Button @click="showSandboxCropModal=false">取消</Button>
          </div>
        </Modal>
        
        <!-- 上传文件Modal -->
        <Modal 
          v-model="showUploadModal" 
          title="上传全景图片"
          width="800"
          :mask-closable="false"
          :closable="true"
          @on-cancel="closeUploadModal"
          class-name="uav-upload-modal-wrapper"
        >
          <div class="uav-upload-modal">
            <div class="uav-upload-header">
              <div class="uav-upload-stats-row">
                <div class="uav-upload-stat">
                  <BaseIcon icon="md-images" size="18" color="var(--primary)" />
                  <span>总计: <strong>{{ uploadFiles.length }}</strong></span>
                </div>
                <div class="uav-upload-stat">
                  <BaseIcon icon="md-checkmark-circle" size="18" color="#19be6b" />
                  <span>成功: <strong>{{ uploadFiles.filter(f => f.status === 'success').length }}</strong></span>
                </div>
                <div class="uav-upload-stat" v-if="uploadFiles.filter(f => f.status === 'error').length > 0">
                  <BaseIcon icon="md-close-circle" size="18" color="#ed4014" />
                  <span>失败: <strong>{{ uploadFiles.filter(f => f.status === 'error').length }}</strong></span>
                </div>
              </div>
            </div>
            
             <div class="uav-upload-list">
               <div 
                 v-for="(file, index) in uploadFiles" 
                 :key="index"
                 :class="['uav-file-card', `uav-file-card-${file.status}`]"
               >
                 <!-- 缩略图预览 -->
                 <div class="uav-file-card-thumb">
                  <template v-if="file.avatar || file.url">
                    <img 
                      :src="file.avatar || file.url" 
                      :alt="file.name"
                      @error="handleImageError"
                    />
                    <div class="uav-file-card-thumb-overlay processing" v-if="file.status === 'processing'">
                      <BaseIcon icon="md-sync" size="24" color="white" class="rotating" />
                    </div>
                    <div class="uav-file-card-thumb-overlay" v-else-if="file.status === 'uploading'">
                      <BaseIcon icon="md-cloud-upload" size="24" color="white" />
                    </div>
                    <div class="uav-file-card-thumb-overlay success" v-else-if="file.status === 'success'">
                      <BaseIcon icon="md-checkmark" size="24" color="white" />
                    </div>
                    <div class="uav-file-card-thumb-overlay error" v-else-if="file.status === 'error'">
                      <BaseIcon icon="md-close" size="24" color="white" />
                    </div>
                  </template>
                  <template v-else>
                    <div class="uav-file-card-thumb-placeholder">
                      <BaseIcon 
                        icon="md-image" 
                        :color="file.status === 'uploading' ? '#2d8cf0' : 'var(--subtext)'"
                        size="32"
                      />
                    </div>
                  </template>
                </div>
                
                <div class="uav-file-card-content">
                  <div class="uav-file-card-header">
                    <div class="uav-file-card-name" :title="file.name">
                      <BaseIcon 
                        :icon="file.status === 'success' ? 'md-checkmark-circle' : file.status === 'error' ? 'md-close-circle' : file.status === 'uploading' ? 'md-cloud-upload' : file.status === 'processing' ? 'md-sync' : 'md-time'" 
                        :color="file.status === 'success' ? '#19be6b' : file.status === 'error' ? '#ed4014' : file.status === 'uploading' || file.status === 'processing' ? '#2d8cf0' : 'var(--subtext)'"
                        :size="16"
                        :class="{ 'rotating': file.status === 'uploading' || file.status === 'processing' }"
                      />
                      {{ file.name }}
                    </div>
                    <div class="uav-file-card-size">
                      {{ formatFileSize(file.size) }}
                    </div>
                  </div>
                  
                  <div class="uav-file-card-progress" v-if="file.status !== 'pending'">
                    <Progress 
                      :percent="file.progress" 
                      :status="file.status === 'success' ? 'success' : file.status === 'error' ? 'wrong' : 'active'"
                      :stroke-width="4"
                      :show-text="false"
                    />
                  </div>
                  
                  <div class="uav-file-card-status">
                    <span v-if="file.status === 'processing'" class="status-processing">
                      <BaseIcon icon="md-sync" size="14" class="rotating" />
                      正在生成缩略图...
                    </span>
                    <span v-else-if="file.status === 'uploading'" class="status-uploading">
                      <BaseIcon icon="md-cloud-upload" size="14" />
                      上传中 {{ file.progress }}%
                    </span>
                    <span v-else-if="file.status === 'success'" class="status-success">
                      <BaseIcon icon="md-checkmark-circle" size="14" />
                      上传成功
                      <span v-if="file.avatar" class="avatar-badge">
                        <BaseIcon icon="md-images" size="12" />
                        含缩略图
                      </span>
                    </span>
                    <span v-else-if="file.status === 'error'" class="status-error">
                      <BaseIcon icon="md-alert" size="14" />
                      {{ file.error || '上传失败' }}
                    </span>
                    <span v-else class="status-pending">
                      <BaseIcon icon="md-time" size="14" />
                      等待上传
                    </span>
                  </div>
                </div>
                
                <div class="uav-file-card-actions">
                  <Button 
                    v-if="file.status === 'uploading'" 
                    size="small" 
                    icon="md-close"
                    @click="cancelUpload(file)"
                  >
                    取消
                  </Button>
                  <Button 
                    v-if="file.status === 'error'" 
                    size="small" 
                    type="primary"
                    icon="md-refresh"
                    @click="retryUpload(file)"
                  >
                    重传
                  </Button>
                  <Button 
                    v-if="file.status === 'success' || file.status === 'error'" 
                    size="small" 
                    icon="md-trash"
                    @click="removeUploadFile(index)"
                  >
                    删除
                  </Button>
                </div>
              </div>
            </div>
            
            <div v-if="uploadFiles.length === 0" class="uav-upload-empty">
              <BaseIcon icon="md-images" size="80" color="var(--subtext)" />
              <div class="uav-upload-empty-text">没有文件</div>
              <div class="uav-upload-empty-hint">请选择全景图片上传</div>
            </div>
          </div>
          
          <div slot="footer" class="uav-upload-footer">
            <div class="uav-upload-footer-left">
              <span v-if="isUploading" style="color:#2d8cf0">
                <BaseIcon icon="md-cloud-upload" size="16" class="rotating" />
                正在上传...
              </span>
              <span v-else-if="uploadCompleted && uploadFiles.some(f => f.status === 'success')" style="color:#19be6b">
                <BaseIcon icon="md-checkmark-circle" size="16" />
                上传完成
              </span>
            </div>
            <div class="uav-upload-footer-right">
              <Button @click="closeUploadModal">取消</Button>
              <Button 
                type="primary" 
                :disabled="isUploading || !uploadFiles.some(f => f.status === 'success')"
                @click="createViewsFromUploads"
                icon="md-checkmark"
              >
                <span v-if="isUploading">处理中...</span>
                <span v-else>创建视图</span>
              </Button>
            </div>
          </div>
        </Modal>
    
      </App>
    </template>
    
    <script>
    import responsableMixin from '@/mixins/responsable';
    import {mapGetters} from 'vuex';
    import App from '@/components/app/app';
    import AppBar from '@/components/app/bar';
    import AppMask from '@/components/app/mask';
    import AppLeft from '@/components/app/left';
    import AppRight from '@/components/app/right';
    import AppAvatar from '@/components/app/avatar';
    import AppClient from '@/components/app/client';
    import UAVRenderEditor from '@/components/uav/editor';
    import SandboxMap from '@/components/uav/sandbox';
    import GFormImageClip from '@/components/form/ImageClip';
    import draggable from 'vuedraggable';
    import UTIL from '@/utils'
    import {cloneDeep} from 'lodash'
    
    export default {
      components: {App, AppBar, AppMask, AppRight, AppClient, AppAvatar,AppLeft,UAVRenderEditor,SandboxMap,GFormImageClip,draggable},
      data() {
        return {
          loading: false,
          showMenu: true,
          showDrawerInput: false,
          view: 'task',
          task: {
            name: '新任务',
          },
          selectedScene: null,
          selectedView: null,
          views: [],
          viewOption: {
            x: 0,
            y: 0,
            z: 0,
            zoom: 75,
          },
          showCreateSceneModal: false,
          showUploadModal: false,
          newSceneName: '',
          uploadFiles: [], // 上传文件列表 {name, size, progress, status, url, error, avatar}
          isUploading: false,
          uploadCompleted: false,
          sandbox: null, // 沙盒数据
          showSandboxCropModal: false,
          sandboxImageUrl: '',
          sandboxData: {
            sandbox_x: 50,
            sandbox_y: 50,
            sandbox_rotate: 0
          },
          sandboxDataChanged: false,
          sceneData: {},
          sceneDataChanged: false,
          viewData: {},
          viewDataChanged: false,
          viewOptionChanged: false,
          draggingView: null, // 正在拖拽的视图
          dragOverScene: null, // 拖拽悬停的场景
          isDraggingFile: false, // 是否正在拖拽文件
          dragCounter: 0, // 拖拽计数器，用于处理嵌套元素
        };
      },
      mixins: [responsableMixin],
      watch: {
        $route: {
          handler(v) {
            this.$api.afterLogin(()=>{  
                this.$store.dispatch('uav-project/loadProject', this.$route.params.id).then(()=>{
                  this.loadScenes();
                });
            })
           
          },
          immediate: true,
          deep: true,
        },
        selectedScene(scene) {
          if (scene && scene.id) {
            this.loadViews(scene.id);
            this.loadSandbox(scene.id);
          } else {
            this.views = [];
            this.selectedView = null;
            this.sandbox = null;
          }
        },
        selectedView(view) {
          if (view && view.option) {
            this.viewOption = {
              x: view.option.x || 0,
              y: view.option.y || 0,
              z: view.option.z || 0,
              zoom: view.option.zoom || 75,
            };
            this.viewOptionChanged = false;
          }
          // 更新视图数据
          if (view) {
            this.viewData = {
              name: view.name || ''
            };
            this.viewDataChanged = false;
            
            // 更新沙盒数据
            this.sandboxData = {
              sandbox_x: view.sandbox_x || 50,
              sandbox_y: view.sandbox_y || 50,
              sandbox_rotate: view.sandbox_rotate || 0
            };
            this.sandboxDataChanged = false;
          }
        },
        selectedScene(scene) {
          if (scene && scene.id) {
            this.loadViews(scene.id);
            this.loadSandbox(scene.id);
          } else {
            this.views = [];
            this.selectedView = null;
            this.sandbox = null;
          }
          // 更新场景数据
          if (scene) {
            this.sceneData = {
              name: scene.name || '',
              description: scene.description || ''
            };
            this.sceneDataChanged = false;
          }
        },
        sandboxData: {
          handler() {
            this.sandboxDataChanged = true;
          },
          deep: true
        },
        sceneData: {
          handler() {
            this.sceneDataChanged = true;
          },
          deep: true
        },
        viewData: {
          handler() {
            this.viewDataChanged = true;
          },
          deep: true
        },
        viewOption: {
          handler() {
            this.viewOptionChanged = true;
          },
          deep: true
        },
      },
      activated() {
        this.$nextTick((e)=>{
          this.calcLayout();
        });
      },
      beforeDestroy() {
        if (this.saveOptionTimer) {
          clearTimeout(this.saveOptionTimer);
        }
      },
      computed: {
        ...mapGetters('session',['session']),
        ...mapGetters('uav-project', ['is_ready','project', 'scene']),
        scenes:{
            get(){
                return this.$store.getters['uav-project/scenes'];
            },
            set(value){
                let arr = cloneDeep(value)
                let old = cloneDeep(this.scenes)
                if(Array.isArray(arr)){
                    arr.forEach((v,i)=>{
                        v.order = i + 1;
                    })
                    this.updateScenes(old,arr)
                    this.$store.commit('uav-project/saveScenes', arr);
                }else{
                    this.$store.commit('uav-project/saveScenes', []);
                }
               
            }
        },
        showHelper() {
          return this.selected && this.selected.id;
        },
        currentView() {
          return this.selectedView || {};
        },
        admin() {
          return this.role == 'admin';
        },
        permissions() {
          if (this.role == 'admin') {
            return true;
          } else {
            return {
    
            };
          }
        },
        // 场景属性配置
        sceneConfig() {
          return [{
            label: '场景名称',
            key: 'name',
            control: 'Text',
            option: {
              placeholder: '请输入场景名称'
            }
          }, {
            label: '场景描述',
            key: 'description',
            control: 'Textarea',
            option: {
              placeholder: '请输入场景描述'
            }
          }];
        },
        // 视图属性配置
        viewConfig() {
          return [{
            label: '视图名称',
            key: 'name',
            control: 'Text',
            option: {
              placeholder: '请输入视图名称'
            }
          }];
        },
        // 视口角度配置
        viewOptionConfig() {
          return [{
            label: '初始角度 X',
            key: 'x',
            control: 'Text',
            option: {
              number: true,
              placeholder: '-360 ~ 360'
            }
          }, {
            label: '初始角度 Y',
            key: 'y',
            control: 'Text',
            option: {
              number: true,
              placeholder: '-85 ~ 85'
            }
          }, {
            label: '初始角度 Z',
            key: 'z',
            control: 'Text',
            option: {
              number: true,
              placeholder: '-360 ~ 360'
            }
          }, {
            label: '放大比率',
            key: 'zoom',
            control: 'Text',
            option: {
              number: true,
              placeholder: '30 ~ 90'
            }
          }];
        },
        // 沙盒位置配置
        sandboxPositionConfig() {
          return [{
            label: '沙盒X坐标',
            key: 'sandbox_x',
            control: 'Text',
            option: {
              number: true,
              placeholder: '0 ~ 100'
            }
          }, {
            label: '沙盒Y坐标',
            key: 'sandbox_y',
            control: 'Text',
            option: {
              number: true,
              placeholder: '0 ~ 100'
            }
          }, {
            label: '沙盒旋转角度',
            key: 'sandbox_rotate',
            control: 'Text',
            option: {
              number: true,
              placeholder: '0 ~ 360'
            }
          }];
        },
      },
      methods: {
        onShare(){
            let baseUrl = location.origin; // 获取当前域名地址和协议
            let shareUrl = baseUrl + `/tools/${this.project.id}/uav720`
            if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
                navigator.clipboard.writeText(shareUrl)
                    .then(() => {
                        this.Success('已复制分享地址!');
                    })
                    .catch(() => {
                        this.Error('复制失败，请手动复制');
                    });
            } else {
                // 如果 clipboard API 不可用，回退到 prompt 让用户手动复制
                try {
                    // 尝试使用旧版 document.execCommand
                    const textArea = document.createElement("textarea");
                    textArea.value = shareUrl;
                    // 使textarea不可见
                    textArea.style.position = "fixed";
                    textArea.style.opacity = "0";
                    document.body.appendChild(textArea);
                    textArea.select();
                    document.execCommand("copy");
                    document.body.removeChild(textArea);
                    this.Success('已复制分享地址!');
                } catch (e) {
                    // 仍然不支持时，弹窗让用户手动复制
                    window.prompt("请手动复制分享地址：", shareUrl);
                }
            }
        },
        updateScenes(old,value){
            if(this.updateScenesTimer)
                clearTimeout(this.updateScenesTimer)
            this.updateScenesTimer = setTimeout(()=>{
                let diff = UTIL.gpt_compare_patched(old,value)
                console.log('diff',value,old,diff)
                if(diff.empty)
                    return
                else{
                    this.$api.patch('uav/projects/${this.project.id}/scenes',diff).then(res=>{

                    }).catch(()=>{
                        this.$Error('更新保存失败')
                    })
                }
            },300)
        },
        handleSandboxChange(view){
            this.saveView(view)
        },
        handleTaskEvent(e) {
    
        },
        loadScenes() {
          if (!this.project || !this.project.id) return;
          
          this.$store.dispatch('uav-project/loadScenes', this.project.id).then(()=>{
            // 默认选中第一个场景（已经在 Vuex mutation 中排序）
            if (this.scenes && this.scenes.length > 0) {
              this.selectedScene = this.scenes[0];
            }
          });
        },
        selectScene(scene) {
          this.selectedScene = scene;
        },
        loadViews(sceneId) {
          this.$api.get(`uav/scenes/${sceneId}/views`).then(res=>{
            this.views = (res.data.data || []).map(view => {
              // 确保 option 对象存在并包含所有必要的字段
              return {
                ...view,
                option: {
                  x: view.x !== undefined ? view.x : (view.option?.x || 0),
                  y: view.y !== undefined ? view.y : (view.option?.y || 0),
                  z: view.z !== undefined ? view.z : (view.option?.z || 0),
                  zoom: view.zoom !== undefined ? view.zoom : (view.option?.zoom || 75),
                },
                sandbox_x: view.sandbox_x !== undefined ? view.sandbox_x : 50,
                sandbox_y: view.sandbox_y !== undefined ? view.sandbox_y : 50,
                sandbox_rotate: view.sandbox_rotate !== undefined ? view.sandbox_rotate : 0,
              };
            });
            // 按 order 排序
            this.views.sort((a, b) => (a.order || 0) - (b.order || 0));
            // 默认选中第一个视图
            if (this.views.length > 0) {
              this.selectedView = this.views[0];
            } else {
              this.selectedView = null;
            }
          }).catch(err=>{
            this.views = [];
            this.selectedView = null;
          });
        },
        selectView(view) {
          this.selectedView = view;
        },
        createScene() {
          this.newSceneName = '';
          this.showCreateSceneModal = true;
        },
        confirmCreateScene() {
          if (!this.newSceneName || !this.newSceneName.trim()) {
            this.$Message.warning('请输入场景名称');
            return;
          }
          this.$store.dispatch('uav-project/postScene', {
            name: this.newSceneName.trim(),
            project_id: this.project.id
          }).then(()=>{
            this.loadScenes();
            this.$Message.success('创建成功');
            this.showCreateSceneModal = false;
            this.newSceneName = '';
          }).catch(err=>{
            this.$Message.error('创建失败');
          });
        },
        cancelCreateScene() {
          this.showCreateSceneModal = false;
          this.newSceneName = '';
        },
        createView() {
          if (!this.selectedScene) {
            this.$Message.warning('请先选择一个场景');
            return;
          }
          // 触发文件选择
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/*';
          input.multiple = true;
          input.onchange = (e) => {
            const files = Array.from(e.target.files);
            if (files.length > 0) {
              this.handleFilesSelected(files);
            }
          };
          input.click();
        },
        handleFilesSelected(files) {
          // 初始化上传文件列表
          this.uploadFiles = files.map(file => ({
            name: file.name,
            size: file.size,
            progress: 0,
            status: 'processing', // processing(生成缩略图), pending, uploading, success, error
            url: '',
            fast_url: '', // 压缩后的快速加载URL
            avatar: '',
            error: '',
            file: file,
            thumbnailFile: null, // 缩略图文件
            fastFile: null, // 压缩后的文件
            fileObject: null, // COS返回的文件对象
            avatarFileObject: null, // 缩略图COS返回的文件对象
            fastFileObject: null, // 压缩文件COS返回的文件对象
          }));
          this.isUploading = false;
          this.uploadCompleted = false;
          this.showUploadModal = true;
          
          // 先生成所有缩略图和压缩图，再上传
          this.$nextTick(() => {
            this.generateAllThumbnails();
          });
        },
        // 生成所有缩略图和压缩图
        async generateAllThumbnails() {
          const promises = this.uploadFiles.map(uploadFile => {
            return this.generateThumbnailAndFast(uploadFile);
          });
          
          try {
            await Promise.all(promises);
            // 所有缩略图和压缩图生成完成，开始上传
            this.startUpload();
          } catch (error) {
            console.error('生成图片失败', error);
            this.$Message.error('生成图片失败');
          }
        },
        
        // 生成单个文件的缩略图和压缩图
        generateThumbnailAndFast(uploadFile) {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            
            reader.onload = (e) => {
              const img = new Image();
              
              img.onload = () => {
                try {
                  // 1. 生成缩略图 (400x300)
                  const thumbCanvas = document.createElement('canvas');
                  const thumbCtx = thumbCanvas.getContext('2d');
                  const thumbWidth = 400;
                  const thumbHeight = 300;
                  thumbCanvas.width = thumbWidth;
                  thumbCanvas.height = thumbHeight;
                  
                  const thumbScale = Math.min(thumbWidth / img.width, thumbHeight / img.height);
                  const thumbScaledWidth = img.width * thumbScale;
                  const thumbScaledHeight = img.height * thumbScale;
                  const thumbOffsetX = (thumbWidth - thumbScaledWidth) / 2;
                  const thumbOffsetY = (thumbHeight - thumbScaledHeight) / 2;
                  
                  thumbCtx.drawImage(img, thumbOffsetX, thumbOffsetY, thumbScaledWidth, thumbScaledHeight);
                  
                  // 2. 检查是否需要压缩（超过4000x2000）
                  const needCompression = img.width > 4000 || img.height > 2000;
                  
                  // 先处理缩略图
                  thumbCanvas.toBlob((thumbBlob) => {
                    if (!thumbBlob) {
                      uploadFile.status = 'error';
                      uploadFile.error = '生成缩略图失败';
                      reject(new Error('生成缩略图失败'));
                      return;
                    }
                    
                    const thumbFile = new File([thumbBlob], `thumb_${uploadFile.name}`, {
                      type: 'image/jpeg'
                    });
                    uploadFile.thumbnailFile = thumbFile;
                    
                    // 如果需要压缩，生成fast_url
                    if (needCompression) {
                      const fastCanvas = document.createElement('canvas');
                      const fastCtx = fastCanvas.getContext('2d');
                      
                      // 计算压缩后的尺寸，保持宽高比
                      let fastWidth = img.width;
                      let fastHeight = img.height;
                      
                      if (fastWidth > 4000) {
                        fastHeight = (fastHeight * 4000) / fastWidth;
                        fastWidth = 4000;
                      }
                      if (fastHeight > 2000) {
                        fastWidth = (fastWidth * 2000) / fastHeight;
                        fastHeight = 2000;
                      }
                      
                      fastCanvas.width = fastWidth;
                      fastCanvas.height = fastHeight;
                      fastCtx.drawImage(img, 0, 0, fastWidth, fastHeight);
                      
                      fastCanvas.toBlob((fastBlob) => {
                        if (!fastBlob) {
                          uploadFile.status = 'error';
                          uploadFile.error = '生成压缩图失败';
                          reject(new Error('生成压缩图失败'));
                          return;
                        }
                        
                        const fastFile = new File([fastBlob], `fast_${uploadFile.name}`, {
                          type: 'image/jpeg'
                        });
                        uploadFile.fastFile = fastFile;
                        uploadFile.status = 'pending';
                        resolve();
                      }, 'image/jpeg', 0.9);
                    } else {
                      // 不需要压缩
                      uploadFile.status = 'pending';
                      resolve();
                    }
                  }, 'image/jpeg', 0.85);
                } catch (error) {
                  uploadFile.status = 'error';
                  uploadFile.error = '生成图片失败';
                  reject(error);
                }
              };
              
              img.onerror = () => {
                uploadFile.status = 'error';
                uploadFile.error = '图片格式错误';
                reject(new Error('图片格式错误'));
              };
              
              img.src = e.target.result;
            };
            
            reader.onerror = () => {
              uploadFile.status = 'error';
              uploadFile.error = '读取文件失败';
              reject(new Error('读取文件失败'));
            };
            
            reader.readAsDataURL(uploadFile.file);
          });
        },
        
        startUpload() {
          this.isUploading = true;
          this.uploadCompleted = false;
          
          // 获取需要上传的文件
          const filesToProcess = this.uploadFiles.filter(f => f.status === 'pending');
          
          if (filesToProcess.length === 0) {
            this.isUploading = false;
            this.uploadCompleted = true;
            return;
          }
          
          // 为每个文件上传原图和缩略图
          filesToProcess.forEach(uploadFile => {
            this.uploadFileAndThumbnail(uploadFile);
          });
        },
        
        // 上传单个文件的原图、压缩图和缩略图
        uploadFileAndThumbnail(uploadFile) {
          uploadFile.status = 'uploading';
          uploadFile.progress = 0;
          
          // 准备上传的文件列表：[原图, 缩略图, 压缩图(如果有)]
          const filesToUpload = [uploadFile.file];
          if (uploadFile.thumbnailFile) {
            filesToUpload.push(uploadFile.thumbnailFile);
          }
          if (uploadFile.fastFile) {
            filesToUpload.push(uploadFile.fastFile);
          }
          
          this.$cos.upload(
            filesToUpload,
            {
              onPreload: (fileObjects) => {
                // 保存 fileObject 引用
                if (fileObjects[0]) {
                  uploadFile.fileObject = fileObjects[0]; // 原图
                }
                if (fileObjects[1]) {
                  uploadFile.avatarFileObject = fileObjects[1]; // 缩略图
                }
                if (fileObjects[2]) {
                  uploadFile.fastFileObject = fileObjects[2]; // 压缩图
                }
              },
              onProgress: (fileObject) => {
                // 只跟踪原图的进度（第一个文件）
                if (fileObject.name === uploadFile.file.name) {
                  uploadFile.progress = parseInt(fileObject.percent) || 0;
                }
              },
              onSuccess: (fileObjects) => {
                // 所有文件都上传成功
                if (fileObjects[0]) {
                  uploadFile.url = fileObjects[0].url;
                }
                if (fileObjects[1]) {
                  uploadFile.avatar = fileObjects[1].url;
                }
                if (fileObjects[2]) {
                  uploadFile.fast_url = fileObjects[2].url;
                }
                uploadFile.progress = 100;
                uploadFile.status = 'success';
                this.checkUploadComplete();
              },
              onFail: (error) => {
                uploadFile.status = 'error';
                uploadFile.error = error || '上传失败';
                this.checkUploadComplete();
              }
            },
            {
              coskey: this.$store.getters['session/session'].coskey
            }
          ).catch(err => {
            uploadFile.status = 'error';
            uploadFile.error = err || '上传失败';
            this.checkUploadComplete();
          });
        },
        checkUploadComplete() {
          const allDone = this.uploadFiles.every(f => 
            f.status === 'success' || f.status === 'error'
          );
          if (allDone) {
            this.isUploading = false;
            this.uploadCompleted = true;
          }
        },
        cancelUpload(file) {
          if (file && file.fileObject && file.fileObject.cancel) {
            file.fileObject.cancel();
            file.status = 'error';
            file.error = '已取消';
            file.progress = 0;
          }
        },
        removeUploadFile(index) {
          this.uploadFiles.splice(index, 1);
          if (this.uploadFiles.length === 0) {
            this.showUploadModal = false;
            this.uploadFiles = [];
            this.isUploading = false;
            this.uploadCompleted = false;
          }
        },
        retryUpload(file) {
          if (file) {
            // 重置状态
            file.status = 'processing';
            file.progress = 0;
            file.error = '';
            file.url = '';
            file.fast_url = '';
            file.avatar = '';
            file.fileObject = null;
            file.avatarFileObject = null;
            file.fastFileObject = null;
            
            // 重新生成缩略图和压缩图并上传
            this.isUploading = true;
            this.uploadCompleted = false;
            
            this.generateThumbnailAndFast(file).then(() => {
              this.uploadFileAndThumbnail(file);
            }).catch(err => {
              file.status = 'error';
              file.error = '生成图片失败';
              this.checkUploadComplete();
            });
          }
        },
        closeUploadModal() {
          if (this.isUploading) {
            this.$Modal.confirm({
              title: '确认关闭',
              content: '文件正在上传中，关闭将终止所有上传任务，确定要关闭吗？',
              onOk: () => {
                // 取消所有正在上传的文件
                this.uploadFiles.forEach(file => {
                  if (file.status === 'uploading' && file.fileObject && file.fileObject.cancel) {
                    file.fileObject.cancel();
                  }
                });
                this.showUploadModal = false;
                this.uploadFiles = [];
                this.isUploading = false;
                this.uploadCompleted = false;
              }
            });
          } else {
            this.showUploadModal = false;
            this.uploadFiles = [];
            this.isUploading = false;
            this.uploadCompleted = false;
          }
        },
        createViewsFromUploads() {
          const successFiles = this.uploadFiles.filter(f => f.status === 'success');
          
          if (successFiles.length === 0) {
            this.$Message.warning('没有成功上传的文件');
            return;
          }
          
          // 获取当前场景的最大order值
          const maxOrder = this.views.length > 0 
            ? Math.max(...this.views.map(v => v.order || 0))
            : 0;
          
          // 创建多个视图
          const promises = successFiles.map((file, index) => {
            const viewName = file.name.replace(/\.[^/.]+$/, ''); // 去掉文件扩展名
            const viewData = {
              url: file.url,
              avatar: file.avatar || '', // 添加缩略图字段
              scene_id: this.selectedScene.id,
              project_id: this.project.id,
              name: viewName,
              order: maxOrder + index + 1, // 新视图放在最后
              option: {
                x: 0,
                y: 0,
                z: 0,
                zoom: 75
              }
            };
            
            // 如果有压缩图，添加 fast_url
            if (file.fast_url) {
              viewData.fast_url = file.fast_url;
            }
            
            return this.$api.post(`uav/views`, viewData);
          });
          
          Promise.all(promises).then(() => {
            this.loadViews(this.selectedScene.id);
            this.$Message.success(`成功创建 ${successFiles.length} 个视图`);
            this.showUploadModal = false;
            this.uploadFiles = [];
            this.isUploading = false;
            this.uploadCompleted = false;
          }).catch(err => {
            this.$Message.error('创建视图失败');
          });
        },
        handleRotationChange(rotation) {
          // 当用户旋转视图时，更新配置
          this.viewOption.x = rotation.x;
          this.viewOption.y = rotation.y;
          this.viewOption.z = rotation.z;
          this.viewOption.zoom = rotation.zoom;
          
          // 标记为已更改，但不自动保存
          this.viewOptionChanged = true;
        },
        // 保存场景数据
        saveSceneData() {
          if (!this.selectedScene || !this.selectedScene.id) return;
          
          this.$api.patch(`uav/scenes/${this.selectedScene.id}`, {
            name: this.sceneData.name,
            description: this.sceneData.description
          }).then(() => {
            this.$Message.success('更新完成');
            // 更新本地数据
            this.selectedScene.name = this.sceneData.name;
            this.selectedScene.description = this.sceneData.description;
            // 更新 store 中的场景列表
            this.loadScenes();
            this.sceneDataChanged = false;
          }).catch(err => {
            this.$Message.error('更新失败: ' + (err.message || '未知错误'));
          });
        },
        saveView(view){
            if (!view || !view.id) return;
          // 保留2位小数
          const sandbox_x = Math.round(view.sandbox_x * 100) / 100;
          const sandbox_y = Math.round(view.sandbox_y * 100) / 100;
          const sandbox_rotate = Math.round(view.sandbox_rotate);
          this.$api.patch(`uav/views/${view.id}`, {
            sandbox_x,
            sandbox_y,
            sandbox_rotate
          }).then(() => {
            
            const oldview = this.views.find(v => v.id === this.selectedView.id);
            this.viewDataChanged = false;
            this.viewOptionChanged = false;
          }).catch(err => {
            this.$Message.error('更新失败: ' + (err.message || '未知错误'));
          });
        },
        // 保存视图数据
        saveViewData(showMessage = true) {
          if (!this.selectedView || !this.selectedView.id) return;
          // 保留2位小数
          const sandbox_x = Math.round(this.sandboxData.sandbox_x * 100) / 100;
          const sandbox_y = Math.round(this.sandboxData.sandbox_y * 100) / 100;
          const sandbox_rotate = Math.round(this.sandboxData.sandbox_rotate);
          this.$api.patch(`uav/views/${this.selectedView.id}`, {
            name: this.viewData.name,
            x: this.viewOption.x,
            y: this.viewOption.y,
            z: this.viewOption.z,
            zoom: this.viewOption.zoom,
            sandbox_x,
            sandbox_y,
            sandbox_rotate
          }).then(() => {
            if(showMessage)
                this.$Message.success('更新完成');
            // 更新本地数据
            this.selectedView.name = this.viewData.name;
            // 更新 selectedView.option，防止被 watch 重置
            this.selectedView.option = {
              x: this.viewOption.x,
              y: this.viewOption.y,
              z: this.viewOption.z,
              zoom: this.viewOption.zoom
            };
            // 更新视图列表中的对应视图
            const view = this.views.find(v => v.id === this.selectedView.id);
            if (view) {
              view.name = this.viewData.name;
              view.option = {...this.selectedView.option};
            }
            this.viewDataChanged = false;
            this.viewOptionChanged = false;
          }).catch(err => {
            this.$Message.error('更新失败: ' + (err.message || '未知错误'));
          });
        },
        // 保存视口角度
        saveViewOption() {
          if (!this.selectedView || !this.selectedView.id) return;
          
          // 直接传递参数，不包裹在option中
          this.$api.patch(`uav/views/${this.selectedView.id}`, {
            x: this.viewOption.x,
            y: this.viewOption.y,
            z: this.viewOption.z,
            zoom: this.viewOption.zoom
          }).then(() => {
            this.$Message.success('更新完成');
            // 更新本地数据
            if (this.selectedView) {
              this.selectedView.option = {...this.viewOption};
            }
            this.viewOptionChanged = false;
          }).catch(err => {
            this.$Message.error('更新失败: ' + (err.message || '未知错误'));
          });
        },
        formatFileSize(bytes) {
          if (bytes === 0) return '0 B';
          const k = 1024;
          const sizes = ['B', 'KB', 'MB', 'GB'];
          const i = Math.floor(Math.log(bytes) / Math.log(k));
          return (bytes / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i];
        },
        // 加载沙盒
        loadSandbox(sceneId) {
          this.$api.get(`uav/sandboxes?scene_id=${sceneId}`).then(res=>{
            const sandboxes = res.data.data || [];
            if (sandboxes.length > 0) {
              this.sandbox = sandboxes[0];
            } else {
              this.sandbox = null;
            }
          }).catch(err=>{
            this.sandbox = null;
          });
        },
        // 创建沙盒
        createSandbox() {
          if (!this.selectedScene) {
            this.$Message.warning('请先选择一个场景');
            return;
          }
          // 清空之前的数据
          this.sandboxImageUrl = '';
          // 显示裁剪对话框
          this.showSandboxCropModal = true;
        },
        // 处理沙盒图片裁剪完成
        handleSandboxImageCropped(url) {
          if (!url) return;
          
          if (this.sandbox && this.sandbox.id) {
            // 更新已有沙盒
            this.$api.patch(`uav/sandboxes/${this.sandbox.id}`, {
              url: url
            }).then(res => {
              this.$Message.success('沙盒更新成功');
              // 强制更新sandbox对象，触发组件刷新
              let newSandbox = {id:this.sandbox.id,url};
              this.$set(this,'sandbox',newSandbox);
              this.showSandboxCropModal = false;
            }).catch(err => {
              this.$Message.error('更新沙盒失败');
            });
          } else {
            // 创建新沙盒
            this.$api.post('uav/sandboxes', {
              url: url,
              project_id: this.project.id,
              scene_id: this.selectedScene.id
            }).then(res => {
               let updateData = res.data.data;
              this.$Message.success('沙盒创建成功');
              let newSandbox = {...updateData,url};
              this.$set(this,'sandbox',newSandbox);
              this.showSandboxCropModal = false;
            }).catch(err => {
              console.error('创建沙盒失败:', err);
              this.$Message.error('创建沙盒失败');
            });
          }
        },
        // 更新沙盒
        updateSandbox() {
          if (!this.sandbox) return;
          // 设置当前沙盒URL用于预览
          this.sandboxImageUrl = this.sandbox.url;
          // 显示裁剪对话框
          this.showSandboxCropModal = true;
        },
        // 沙盒中选中视图
        handleSandboxSelectView(viewId) {
          const view = this.views.find(v => v.id === viewId);
          if (view) {
            this.selectedView = view;
          }
        },
        // 保存沙盒位置
        saveSandboxPosition() {
          if (!this.selectedView || !this.selectedView.id) return;
          
          // 保留2位小数
          const sandbox_x = Math.round(this.sandboxData.sandbox_x * 100) / 100;
          const sandbox_y = Math.round(this.sandboxData.sandbox_y * 100) / 100;
          const sandbox_rotate = Math.round(this.sandboxData.sandbox_rotate);
          
          this.$api.patch(`uav/views/${this.selectedView.id}`, {
            sandbox_x,
            sandbox_y,
            sandbox_rotate
          }).then(() => {
            this.$Message.success('更新完成');
            // 更新本地数据
            this.selectedView.sandbox_x = sandbox_x;
            this.selectedView.sandbox_y = sandbox_y;
            this.selectedView.sandbox_rotate = sandbox_rotate;
            
            // 更新 sandboxData
            this.sandboxData.sandbox_x = sandbox_x;
            this.sandboxData.sandbox_y = sandbox_y;
            this.sandboxData.sandbox_rotate = sandbox_rotate;
            
            // 更新视图列表中的数据
            const view = this.views.find(v => v.id === this.selectedView.id);
            if (view) {
              view.sandbox_x = sandbox_x;
              view.sandbox_y = sandbox_y;
              view.sandbox_rotate = sandbox_rotate;
            }
            
            this.sandboxDataChanged = false;
          }).catch(err => {
            this.$Message.error('更新失败: ' + (err.message || '未知错误'));
          });
        },
        // 更新沙盒位置（拖动时的临时更新）
        handleUpdateSandboxPosition(data) {
          // data: { viewId, sandbox_x, sandbox_y, sandbox_rotate }
          if (!data.viewId) return;
          
          // 更新本地显示数据（不保存到服务器）
          if (this.selectedView && this.selectedView.id === data.viewId) {
            this.selectedView.sandbox_x = data.sandbox_x;
            this.selectedView.sandbox_y = data.sandbox_y;
            this.selectedView.sandbox_rotate = data.sandbox_rotate;
            
            // 同步更新sandboxData
            this.sandboxData.sandbox_x = data.sandbox_x;
            this.sandboxData.sandbox_y = data.sandbox_y;
            this.sandboxData.sandbox_rotate = data.sandbox_rotate;
          }
          // 更新views列表中的数据
          const view = this.views.find(v => v.id === data.viewId);
          if (view) {
            view.sandbox_x = data.sandbox_x;
            view.sandbox_y = data.sandbox_y;
            view.sandbox_rotate = data.sandbox_rotate;
          }
          this.handleSandboxChange(view)
        },
        // 图片加载错误处理
        handleImageError(e) {
          e.target.style.display = 'none';
        },
        // 视图拖拽到场景开始（通过拖拽手柄）
        handleViewDragToSceneStart(view, event) {
          this.draggingView = view;
          event.dataTransfer.effectAllowed = 'move';
          event.dataTransfer.setData('text/plain', view.id);
        },
        // 视图拖拽到场景结束
        handleViewDragToSceneEnd(event) {
          this.draggingView = null;
          this.dragOverScene = null;
        },
        // 视图拖拽悬停在场景上
        handleViewDragOverScene(scene, event) {
          if (this.draggingView && this.draggingView.scene_id !== scene.id) {
            this.dragOverScene = scene;
            event.dataTransfer.dropEffect = 'move';
          } else if (this.draggingView && this.draggingView.scene_id === scene.id) {
            event.dataTransfer.dropEffect = 'none';
          }
        },
        // 视图拖拽离开场景
        handleViewDragLeaveScene(scene, event) {
          // 只有当离开的目标是场景本身时才清除状态
          if (this.dragOverScene && this.dragOverScene.id === scene.id) {
            // 检查鼠标是否真的离开了这个元素（而不是进入子元素）
            const rect = event.currentTarget.getBoundingClientRect();
            const x = event.clientX;
            const y = event.clientY;
            
            if (x < rect.left || x >= rect.right || y < rect.top || y >= rect.bottom) {
              this.dragOverScene = null;
            }
          }
        },
        // 视图拖拽放置到场景
        handleViewDropToScene(targetScene) {
          if (!this.draggingView) return;
          
          const draggedView = this.draggingView;
          const oldSceneId = draggedView.scene_id;
          
          // 如果是同一个场景，不需要操作
          if (oldSceneId === targetScene.id) {
            this.dragOverScene = null;
            this.$Message.info('视图已在当前场景中');
            return;
          }
          
          // 更新视图的场景ID
          this.$api.patch(`uav/views/${draggedView.id}`, {
            scene_id: targetScene.id
          }).then(() => {
            this.$Message.success(`已将"${draggedView.name}"移动到场景"${targetScene.name}"`);
            
            // 重新加载原场景的视图（如果是当前选中的场景）
            if (this.selectedScene && this.selectedScene.id === oldSceneId) {
              this.loadViews(oldSceneId);
            }
            
            // 如果移动到的场景是当前选中的场景，也重新加载
            if (this.selectedScene && this.selectedScene.id === targetScene.id) {
              this.loadViews(targetScene.id);
            }
            
            // 清除拖拽状态
            this.dragOverScene = null;
          }).catch(err => {
            this.$Message.error('移动失败: ' + (err.message || '未知错误'));
            this.dragOverScene = null;
          });
        },
        // 场景拖拽排序结束
        handleSceneSortEnd(evt) {
          // 获取重新排序后的场景列表
          const reorderedScenes = [...this.scenes];
          
          // 更新 order 字段
          const updates = [];
          reorderedScenes.forEach((scene, index) => {
            const newOrder = index + 1;
            if (scene.order !== newOrder) {
              updates.push({
                id: scene.id,
                order: newOrder
              });
            }
          });
          
          // 批量更新有变化的场景
          if (updates.length > 0) {
            Promise.all(updates.map(update => 
              this.$api.patch(`uav/scenes/${update.id}`, { order: update.order })
            )).then(() => {
              // 更新本地数据和 Vuex store
              reorderedScenes.forEach((scene, index) => {
                scene.order = index + 1;
              });
              // 提交到 Vuex store
              this.$store.commit('uav-project/saveScenes', reorderedScenes);
              this.$Message.success('场景排序已更新');
            }).catch(err => {
              this.$Message.error('更新排序失败');
              // 重新加载场景列表
              this.loadScenes();
            });
          }
        },
        // 视图拖拽排序结束
        handleViewSortEnd(evt) {
          // 更新 order 字段
          const updates = [];
          this.views.forEach((view, index) => {
            const newOrder = index + 1;
            if (view.order !== newOrder) {
              updates.push({
                id: view.id,
                order: newOrder
              });
            }
          });
          
          // 批量更新有变化的视图
          if (updates.length > 0) {
            Promise.all(updates.map(update => 
              this.$api.patch(`uav/views/${update.id}`, { order: update.order })
            )).then(() => {
              // 更新本地数据
              this.views.forEach((view, index) => {
                view.order = index + 1;
              });
              this.$Message.success('视图排序已更新');
            }).catch(err => {
              this.$Message.error('更新排序失败');
              // 重新加载视图列表
              if (this.selectedScene) {
                this.loadViews(this.selectedScene.id);
              }
            });
          }
        },
        // 文件拖拽进入
        handleFileDragEnter(e) {
          e.preventDefault();
          this.dragCounter++;
          if (e.dataTransfer.types.includes('Files')) {
            this.isDraggingFile = true;
          }
        },
        // 文件拖拽离开
        handleFileDragLeave(e) {
          e.preventDefault();
          this.dragCounter--;
          if (this.dragCounter === 0) {
            this.isDraggingFile = false;
          }
        },
        // 文件拖拽释放
        handleFileDrop(e) {
          e.preventDefault();
          this.dragCounter = 0;
          this.isDraggingFile = false;
          
          if (!this.selectedScene) {
            this.$Message.warning('请先选择一个场景');
            return;
          }
          
          const files = Array.from(e.dataTransfer.files);
          const imageFiles = files.filter(file => file.type.startsWith('image/'));
          
          if (imageFiles.length === 0) {
            this.$Message.warning('请拖拽图片文件');
            return;
          }
          
          // 调用上传文件处理
          this.handleFilesSelected(imageFiles);
        },
      },
    };
    </script>
    
    <style lang="less">
    .uav-project-editor {
      .uav-panel {
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: hidden;
      }
      
      .uav-panel-header {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 2px 5px;
        background: var(--bg2);
        border-bottom: 1px solid var(--border);
      }
      
      .uav-panel-title {
        font-size: 14px;
        color: var(--text);
      }
      
      .uav-panel-content {
        flex: 1;
        height:calc(100% - 30px);
      }
      
      .uav-empty-panel {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        min-height: 150px;
        cursor: pointer;
        transition: all 0.3s;
        
        &:hover {
          background: var(--border);
          i{
            color:var(--primary) !important;
            }
        }

        &:active{
            i{
                position: relative;
                right:-1px;
                bottom:-1px;
            }
        }
       
      }
      
      .uav-empty-hint {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        min-height: 150px;
        opacity: 0.7;
      }
      
      .uav-scene-list {
        padding: 8px;
      }
      
      .uav-scene-item {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px 12px;
        margin-bottom: 6px;
        background: var(--bg);
        border: 1px solid var(--border);
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.3s;
        position: relative;
        
        &:hover {
          background: var(--bg2);
          border-color: var(--primary);
        }
        
        &.uav-scene-selected {
          background: var(--primary);
          border-color: var(--primary);
          color: white;
          
          .uav-scene-name {
            color: white;
            font-weight: 600;
          }
          
          .uav-view-drag-handle {
            i {
              color: white !important;
            }
          }
        }
        
        &.uav-scene-add {
          border-style: dashed;
          opacity: 0.7;
          
          &:hover {
            opacity: 1;
          }
        }
        
        // 场景拖拽悬停状态
        &.uav-scene-drag-over {
          background: rgba(45, 140, 240, 0.1);
          border-color: #2d8cf0;
          border-width: 2px;
          border-style: dashed;
          box-shadow: 0 0 12px rgba(45, 140, 240, 0.3);
          
          &::before {
            content: '释放以移动到此场景';
            position: absolute;
            top: -25px;
            left: 50%;
            transform: translateX(-50%);
            background: #2d8cf0;
            color: white;
            padding: 4px 12px;
            border-radius: 4px;
            font-size: 11px;
            white-space: nowrap;
            z-index: 10;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          }
        }
      }
      
      // 视图项特殊样式
      .uav-view-item {
        cursor: move;
        user-select: none;
        
        &.uav-view-dragging {
          opacity: 0.5;
          transform: scale(0.95);
        }
        
        .uav-view-drag-handle {
          opacity: 0;
          transition: opacity 0.2s;
          margin-left: auto;
          flex-shrink: 0;
        }
        
        &:hover .uav-view-drag-handle {
          opacity: 1;
        }
        
        &.uav-scene-selected {
          .uav-view-drag-handle {
            opacity: 0.8;
            
            &:hover {
              opacity: 1;
            }
          }
        }
      }
      
      .uav-scene-name {
        flex: 1;
        font-size: 13px;
        color: var(--text);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        user-select: none;
      }
      
      // 拖拽手柄
      .drag-handle {
        cursor: move;
        opacity: 0.5;
        transition: opacity 0.2s;
        margin-right: 4px;
        flex-shrink: 0;
        
        &:hover {
          opacity: 1;
        }
      }
      
      .uav-scene-item:hover .drag-handle {
        opacity: 0.8;
      }
      
      .uav-scene-selected .drag-handle {
        i {
          color: white !important;
        }
      }
      
      // 文件拖拽区域
      .uav-panel-drop-zone {
        position: relative;
        border: 2px dashed #2d8cf0 !important;
        background: rgba(45, 140, 240, 0.05);
      }
      
      .uav-drop-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(45, 140, 240, 0.1);
        backdrop-filter: blur(4px);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 100;
        pointer-events: none;
      }
      
      .uav-config-panel {
        height: 100%;
        display: flex;
        flex-direction: column;
        background: var(--bg);
      }
      
      .uav-empty-config {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        background: var(--border);
      }
      
      .uav-config-content {
        flex: 1;
        overflow-y: auto;
      }
      
      .uav-config-section {
        padding: 5px 0;
      }
      
      .uav-config-section-title {
        font-size: 13px;
        font-weight: 600;
        color: var(--text);
        border-bottom: 1px solid var(--border);
        padding:0 5px;
        height:32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        
        > span {
          flex: 1;
        }
        
        .ivu-icon {
          transition: all 0.2s;
          
          &:hover {
            transform: scale(1.2);
            filter: brightness(1.2);
          }
        }
      }
      
      .uav-empty-viewport {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
      }
      
     
    
    .pm-panel-flex{
      display: flex;
    }
    .pm-panel-editing-wrap:hover{
      filter:brightness(1.2);
      cursor: pointer;
    }
    
    .pm-panel-selected{
      background:#fbbd2162 !important;
    }
    
    .itask-action-button{
      width:60px;height:60px;background:var(--bg2);margin:5px;border-radius:10px;box-shadow:1px 1px 2px 1px var(--border);padding-top:5px;
      font-size:12px;
      font-weight: bold;
      color:var(--subtext2);
      cursor: pointer;
      transition:all 0.3s;
      border:1px solid var(--border);
    }
    
    .itask-action-button:hover{
      filter:brightness(1.05);
    }
    
    .itask-action-button:active{
      position: relative;
      right:-1px;
      bottom:-1px;
    }

    }

    // 上传Modal样式
      .uav-upload-modal {
        max-height: 550px;
        overflow-y: auto;
        overflow-x: hidden;
        
        &::-webkit-scrollbar {
          width: 6px;
        }
        
        &::-webkit-scrollbar-track {
          background: var(--border);
          border-radius: 3px;
        }
        
        &::-webkit-scrollbar-thumb {
          background: var(--subtext);
          border-radius: 3px;
          
          &:hover {
            background: var(--text);
          }
        }
      }
      
      .uav-upload-header {
        padding: 12px 16px;
        background: var(--bg2);
        border-radius: 8px;
        margin-bottom: 15px;
      }
      
      .uav-upload-stats-row {
        display: flex;
        align-items: center;
        gap: 30px;
        justify-content: flex-start;
      }
      
      .uav-upload-stat {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 13px;
        color: var(--text);
        white-space: nowrap;
        
        strong {
          font-weight: 600;
          font-size: 14px;
        }
      }
      
      .uav-upload-list {
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 0 5px;
      }
      
      .uav-file-card {
        display: flex;
        align-items: stretch;
        gap: 15px;
        padding: 12px;
        background: var(--bg);
        border: 2px solid var(--border);
        border-radius: 10px;
        transition: all 0.3s ease;
        animation: slideIn 0.3s ease-out;
        
        &:hover {
          border-color: var(--primary);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          transform: translateY(-2px);
        }
        
        &.uav-file-card-processing {
          border-color: #9b59b6;
          background: linear-gradient(135deg, rgba(155, 89, 182, 0.08) 0%, transparent 100%);
        }
        
        &.uav-file-card-uploading {
          border-color: #2d8cf0;
          background: linear-gradient(135deg, rgba(45, 140, 240, 0.08) 0%, transparent 100%);
        }
        
        &.uav-file-card-success {
          border-color: #19be6b;
          background: linear-gradient(135deg, rgba(25, 190, 107, 0.08) 0%, transparent 100%);
        }
        
        &.uav-file-card-error {
          border-color: #ed4014;
          background: linear-gradient(135deg, rgba(237, 64, 20, 0.08) 0%, transparent 100%);
        }
      }
      
      @keyframes slideIn {
        from {
          opacity: 0;
          transform: translateY(-10px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      
      .uav-file-card-thumb {
        flex-shrink: 0;
        width: 100px;
        height: 60px;
        border-radius: 6px;
        overflow: hidden;
        position: relative;
        background: var(--bg2);
        border: 1px solid var(--border);
        
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .uav-file-card-thumb-placeholder {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--bg2);
        }
        
        .uav-file-card-thumb-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(45, 140, 240, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          
          &.processing {
            background: rgba(155, 89, 182, 0.7);
          }
          
          &.success {
            background: rgba(25, 190, 107, 0.7);
          }
          
          &.error {
            background: rgba(237, 64, 20, 0.7);
          }
        }
      }
      
      .uav-file-card-content {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 6px;
      }
      
      .uav-file-card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
      }
      
      .uav-file-card-name {
        flex: 1;
        font-size: 13px;
        font-weight: 600;
        color: var(--text);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        align-items: center;
        gap: 6px;
      }
      
      .uav-file-card-size {
        font-size: 12px;
        color: var(--subtext);
        flex-shrink: 0;
        font-weight: 500;
      }
      
      .uav-file-card-progress {
        margin: 4px 0;
      }
      
      .uav-file-card-status {
        font-size: 12px;
        font-weight: 500;
        
        span {
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }
        
        .status-processing {
          color: #9b59b6;
        }
        
        .status-uploading {
          color: #2d8cf0;
        }
        
        .status-success {
          color: #19be6b;
        }
        
        .status-error {
          color: #ed4014;
        }
        
        .status-pending {
          color: var(--subtext);
        }
        
        .avatar-badge {
          display: inline-flex;
          align-items: center;
          gap: 2px;
          margin-left: 6px;
          padding: 2px 6px;
          background: rgba(25, 190, 107, 0.1);
          border-radius: 4px;
          font-size: 11px;
          color: #19be6b;
          font-weight: 600;
        }
      }
      
      .uav-file-card-actions {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        gap: 6px;
        justify-content: center;
      }
      
      .uav-upload-empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 80px 20px;
        color: var(--subtext);
        
        .uav-upload-empty-text {
          margin-top: 15px;
          font-size: 16px;
          font-weight: 600;
          color: var(--text);
        }
        
        .uav-upload-empty-hint {
          margin-top: 8px;
          font-size: 13px;
          color: var(--subtext);
        }
      }
      
      .uav-upload-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 10px;
        
        .uav-upload-footer-left {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 13px;
          font-weight: 500;
        }
        
        .uav-upload-footer-right {
          display: flex;
          gap: 8px;
        }
      }
      
      .rotating {
        animation: rotate 1s linear infinite;
      }
      
      @keyframes rotate {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
    

    </style>
    